import React, {Fragment,Component,useState,useEffect} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const [synchronized, setSynchronized] = useState(true);
  const [current, setCurrent] = useState(0);

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  var subscribe_endpoint = "update.glados-config.com";
  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";

  const suburl           = `https://${subscribe_endpoint}/singbox/${user_id}/${hashed}#GLaDOS`
  const android_suburl   = `https://${subscribe_endpoint}/sfa/${user_id}/${hashed}#GLaDOS`

  const winDownload         = "https://glados.one/tools/Hiddify-Windows-Setup-x64.exe";
  const macDownload         = "https://glados.one/tools/Hiddify-MacOS.dmg";
  const apkDownload         = "https://glados.one/tools/Hiddify-Android-universal.apk";

  const [clipboard,setClipboard] = useState(false);

  useEffect(()=>{
    if(clipboard == true){
      setTimeout(()=>{
        setClipboard(false)
      },3000)
    }
  },[clipboard])

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.singbox.title")}
      <Header.Subheader>
      {t("settings.singbox.notes")}
      </Header.Subheader>
    </Header>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            Clients
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>

              <Tab menu={{ color:"blue", secondary: true}} panes={[
                {
                  menuItem:<Menu.Item key='pro33'>
                  <svg id="macos" viewBox="0 0 36 24" style={{"color":"#333","width":"28px","marginRight":"8px", "verticalAlign": "middle"}} >
                  <path fillRule="evenodd" clipRule="evenodd" d="M15.8794 12.7011C16.0168 10.3047 17.0395 6.40098 19.2618 2H8C6.89543 2 6 2.89543 6 4V20C6 21.1046 6.89543 22 8 22H19.3675C19.1836 20.8126 19.1204 19.6274 19.1251 18.5173C18.6765 18.5758 18.2212 18.6074 17.7647 18.6074C16.1518 18.6074 14.553 18.2135 13.2161 17.6272C11.8949 17.0477 10.7514 16.2451 10.1175 15.3648C9.88356 15.0399 9.95732 14.5868 10.2823 14.3528C10.6072 14.1189 11.0603 14.1926 11.2942 14.5176C11.7192 15.1078 12.6052 15.7759 13.7986 16.2993C14.9764 16.8159 16.3776 17.1574 17.7647 17.1574C18.2344 17.1574 18.7057 17.1182 19.1695 17.0463C19.2362 15.825 19.3653 14.7574 19.4682 13.9668H17.0882C16.4229 13.9668 15.8383 13.4198 15.8794 12.7011ZM20.578 18.2311C21.1884 18.0702 21.7723 17.8645 22.3133 17.6272C23.6346 17.0477 24.7781 16.2451 25.4119 15.3648C25.6459 15.0399 25.5721 14.5868 25.2472 14.3528C24.9222 14.1189 24.4691 14.1926 24.2352 14.5176C23.8102 15.1078 22.9243 15.7759 21.7309 16.2993C21.3857 16.4507 21.0213 16.587 20.6438 16.7041C20.7199 15.5944 20.844 14.6233 20.9397 13.8982C21.0365 13.164 20.4648 12.5168 19.7277 12.5168H17.346C17.5383 10.2196 18.5895 6.37024 20.8934 2H28C29.1046 2 30 2.89543 30 4V20C30 21.1046 29.1046 22 28 22H20.8358C20.6199 20.723 20.5588 19.4319 20.578 18.2311ZM12.5 6.275C12.9004 6.275 13.225 6.59959 13.225 7V9.35294C13.225 9.75335 12.9004 10.0779 12.5 10.0779C12.0996 10.0779 11.775 9.75335 11.775 9.35294V7C11.775 6.59959 12.0996 6.275 12.5 6.275ZM24.225 7C24.225 6.59959 23.9004 6.275 23.5 6.275C23.0996 6.275 22.775 6.59959 22.775 7V9.35294C22.775 9.75335 23.0996 10.0779 23.5 10.0779C23.9004 10.0779 24.225 9.75335 24.225 9.35294V7Z" fill="currentColor"></path>
                  </svg>
                  MacOS</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
                      <h3 style={{"color":"green","weight":"bold"}}>Singbox Official</h3>
                      <p>1. Get App from <a href="https://apps.apple.com/us/app/sing-box-vt/id6673731168">App Store</a></p>
                      <p>2. Copy this URL <Clipboard
                      style={{"borderRadius": "5px", "padding": "4px"}}
                      onSuccess={()=>{ setClipboard(true) }}
                      data-clipboard-text={suburl}>
                      { clipboard ? "copied" : "copy to clipboard" }
                      </Clipboard> {suburl}</p>
                        <p>3. Add subscription in Singbox</p>
                        <p>4. Click Start</p>
                      <p>Github: https://sing-box.sagernet.org/</p>
                    </Tab.Pane>)
                  }
                },{
                  menuItem:<Menu.Item key='pro33'>
                  <svg id="apple" style={{"color":"#333","width":"26px","marginRight":"8px","marginTop":"-4px", "verticalAlign": "middle"}}   viewBox="0 0 36 24">
                  <path fillRule="evenodd" clipRule="evenodd" d="M18.7954 2.08851C20.3723 0.0101142 22.5646 0 22.5646 0C22.5646 0 22.8906 1.95403 21.3241 3.8364C19.6514 5.8464 17.7501 5.51751 17.7501 5.51751C17.7501 5.51751 17.3931 3.93677 18.7954 2.08851V2.08851ZM17.9507 6.88629C18.7619 6.88629 20.2675 5.77114 22.2273 5.77114C25.6007 5.77114 26.9279 8.17157 26.9279 8.17157C26.9279 8.17157 24.3323 9.4986 24.3323 12.7186C24.3323 16.3511 27.5657 17.6031 27.5657 17.6031C27.5657 17.6031 25.3054 23.9648 22.2524 23.9648C20.8502 23.9648 19.7601 23.0199 18.2826 23.0199C16.7771 23.0199 15.283 24 14.3098 24C11.522 24.0001 8 17.9653 8 13.1144C8 8.34171 10.9811 5.838 13.7773 5.838C15.5951 5.838 17.0057 6.88629 17.9507 6.88629V6.88629Z" fill="currentColor"/>
                  </svg>
                  iOS</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

                        <h3 style={{"color":"green","weight":"bold"}}>Singbox Official</h3>
                        <p>1. Get App from <a href="https://apps.apple.com/us/app/sing-box-vt/id6673731168">App Store</a></p>
                        <p>2. Copy this URL <Clipboard
                      style={{"borderRadius": "5px", "padding": "4px"}}
                      onSuccess={()=>{ setClipboard(true) }}
                      data-clipboard-text={suburl}>
                      { clipboard ? "copied" : "copy to clipboard" }
                      </Clipboard> {suburl}</p>

                        <p>3. Add subscription in Singbox</p>
                        <p>4. Click Start</p>

                        <p>Github: https://sing-box.sagernet.org/</p>

                        </Tab.Pane>)
                  }
                },{
                  menuItem:<Menu.Item key='pro33'>
        <svg id="apple" style={{"color":"#333","width":"26px","marginRight":"8px","marginTop":"-4px", "verticalAlign": "middle"}}   viewBox="0 0 36 24">
          <path fillRule="evenodd" clipRule="evenodd" d="M18.7954 2.08851C20.3723 0.0101142 22.5646 0 22.5646 0C22.5646 0 22.8906 1.95403 21.3241 3.8364C19.6514 5.8464 17.7501 5.51751 17.7501 5.51751C17.7501 5.51751 17.3931 3.93677 18.7954 2.08851V2.08851ZM17.9507 6.88629C18.7619 6.88629 20.2675 5.77114 22.2273 5.77114C25.6007 5.77114 26.9279 8.17157 26.9279 8.17157C26.9279 8.17157 24.3323 9.4986 24.3323 12.7186C24.3323 16.3511 27.5657 17.6031 27.5657 17.6031C27.5657 17.6031 25.3054 23.9648 22.2524 23.9648C20.8502 23.9648 19.7601 23.0199 18.2826 23.0199C16.7771 23.0199 15.283 24 14.3098 24C11.522 24.0001 8 17.9653 8 13.1144C8 8.34171 10.9811 5.838 13.7773 5.838C15.5951 5.838 17.0057 6.88629 17.9507 6.88629V6.88629Z" fill="currentColor"/>
        </svg>

                  tvOS</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
                        <h3 style={{"color":"green","weight":"bold"}}>Singbox Official</h3>

                        <p>1. Search Singbox in App Store on your AppleTV</p>
                        <p>2. Copy URL <Clipboard
                      style={{"borderRadius": "5px", "padding": "4px"}}
                      onSuccess={()=>{ setClipboard(true) }}
                      data-clipboard-text={suburl}>
                      { clipboard ? "copied" : "copy to clipboard" }
                      </Clipboard> {suburl}</p>
                        <p>3. Add subscription in Singbox</p>
                        <p>4. Start</p>

                    </Tab.Pane>)
                  }
                },{
                  menuItem:<Menu.Item key='pro33'>
                  <svg focusable="false" style={{"color":"#333","width":"26px","marginRight":"8px", "verticalAlign": "middle"}}  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"></path></svg>
                  Android</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
                          <h3 style={{"color":"green","weight":"bold"}}>Singbox Official</h3>
                          <p>1. Install from https://install.appcenter.ms/users/nekohasekai/apps/sfa/distribution_groups/publictest</p>
                          <p>2. Copy URL <Clipboard
                      style={{"borderRadius": "5px", "padding": "4px"}}
                      onSuccess={()=>{ setClipboard(true) }}
                      data-clipboard-text={android_suburl}>
                      { clipboard ? "copied" : "copy to clipboard" }
                      </Clipboard> {android_suburl}</p>
                        <p>3. Add subscription in Singbox</p>
                        <p>4. Start</p>
                    </Tab.Pane>)
                  }
                },
                {
                  menuItem:<Menu.Item key='pro33'>
                  <svg id="windows" style={{"color":"#333","width":"26px","marginRight":"8px", "verticalAlign": "middle"}}   viewBox="0 0 36 24">
                  <path d="M6.5 3.27934L15.9055 1.99281V11.051H6.5V3.27934ZM17.0384 1.81427L29.5 0V10.9749H17.0384V1.81427ZM6.5 12.0094H15.9055V21.0938L6.5 19.7811V12.0094ZM17.0384 12.1301H29.5V23L17.0384 21.2409" fill="currentColor"></path>
                  </svg>
                Windows</Menu.Item>,
                  render: () => {
                    return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
                        <h3 style={{"color":"green","weight":"bold"}}>Singbox Official</h3>
                        <p>Official Singbox Desktop is still working in progress</p>
                        <h3 style={{"color":"green","weight":"bold"}}>Hiddify For Windows</h3>
                        <p>A multi-platform proxy client based on Singbox.</p>
                        <p>Singbox Github: https://sing-box.sagernet.org</p>
                        <p>Hiddify Github: https://github.com/hiddify/hiddify-next</p>
                        <p>1. Download App from <a href={winDownload}>Here</a></p>
                        <p>2. Copy this URL <Clipboard
                      style={{"borderRadius": "5px", "padding": "4px"}}
                      onSuccess={()=>{ setClipboard(true) }}
                      data-clipboard-text={suburl}>
                      { clipboard ? "copied" : "copy to clipboard" }
                      </Clipboard> {suburl}</p>
                        <p>3. Add subscription(+) in Hiddify, Choose Manual Entry, Paste in the URL get from step 2</p>
                        <p>4. Click Connect</p>

                        </Tab.Pane>)
                  }
                },
              ]} />
        </Segment>
      </Table.Body>
    </Table>

  </Fragment>
  )
}
export {Guide};
